import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BookSwitchData,
  PersonUsesBook,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ScopeDto } from './scope.model';

export const ScopeActions = createActionGroup({
  source: 'Scope API',
  events: {
    'Get Person Scopes': emptyProps(),
    'Get Person Scopes Success': props<{ scopes: ScopeDto[] }>(),
    'Get Person Scopes Failure': props<{ error: Error }>(),
    'Switch Book Success': props<{
      scope: ScopeDto;
      oldPersonUsesBook: PersonUsesBook | undefined;
    }>(),
    'Switch Book Failure': props<{ error: Error }>(),
    'Switch Books Success': props<{ scopes: ScopeDto[] }>(),
    'Switch Books Failure': props<{ error: Error }>(),
  },
});

export const BookSelectModalActions = createActionGroup({
  source: 'Book Select Modal',
  events: {
    'Book Selected': props<{ payload: BookSwitchData }>(),
    'Modal Closed': emptyProps(),
  },
});
